import { computed, Injectable, Signal, signal } from '@angular/core';
import { userDtos } from '@vectronic/openApi-customer';
import moment from 'moment';
import { guessTimezone } from '../helpers/timezone/guess-timezone';
import { momentTimezone } from '../helpers/timezone/moment-timezone';

@Injectable({ providedIn: 'root' })
export class TimeService {
  private userPreferences: Signal<userDtos.UserPreferences> = signal(undefined);
  localTimeZone = computed(() => {
    const userPreferences = this.userPreferences();
    if (userPreferences?.timezoneType === 'custom') {
      return userPreferences.timezone || guessTimezone();
    }
    return guessTimezone();
  });
  shouldShowLocalTime = computed(() => this.userPreferences()?.showLmt ?? true);

  setUserPreferences(userPreferencesSignal: Signal<userDtos.UserPreferences>) {
    this.userPreferences = userPreferencesSignal;
  }

  convertLocalToUtc(date: string | moment.Moment) {
    const wallClockTime = moment(date).format('YYYY-MM-DD HH:mm:ss');
    return momentTimezone(wallClockTime, this.localTimeZone()).toISOString();
  }

  convertToLocalTime(date: string) {
    return momentTimezone(date, this.localTimeZone())
      .milliseconds(0)
      .toISOString(true)
      .replace('.000', '')
      .replace('T', ' ');
  }
}
